//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
import config from '../../config';
import { withStyles } from "@material-ui/core/styles";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import { participantActions } from "../../_actions";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import DatePicker from "react-datepicker";
import { commonService } from "../../_services";

const styles = theme => ({
    error: {
        color: 'red',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
    contentRoot: {
        padding: theme.spacing(2),
        fontSize: 14,
        width: 600
    },
    actionRoot: {
        margin: 0,
        padding: theme.spacing(1)
    },
    pageImg: {
        width: '70px',
        height: '70px',
        position: 'relative',
        padding: '10px'
    },
    tableImg: {
        width: '50px',
        height: '50px',
        position: 'relative',
        padding: '3px'
    },

    removeImg: {
        position: 'absolute',
        top: '-7px',
        right: '-7px',
        padding: '0px 7px 0px 7px',
        border: '1px solid #a09d9d',
        background: '#c1c1c1',
        borderRadius: '50%',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#fff'
    },
    borderedImg: {
        position: 'relative',
        width: '70px',
        height: '70px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '15px',
        marginRight: '15px'
    },
    borderedImgTable: {
        position: 'relative',
        width: '52px',
        height: '52px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '8px',
        marginRight: '8px'
    }
});

class Participant extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            advertisments: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
            participantAdd: false,
            participantTitle: '',
            participantError: '',
            participantSuccess: '',
            getParticipantsList: [],
            addParticipant: false,
            editingParticipantId: '',
            editingParticipantTitle: '',
            editingCatStatus: '',
            editingParticipantHold: false,
            perPage: config.perPageData,
            participant_image: ''
        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(participantActions.getParticipantsList(apiConstants.GET_PARTICIPANT, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {

        const { dispatch } = props;
        if (props.deleteParticipant.deleteParticipant !== undefined &&
            props.deleteParticipant.deleteParticipant.data !== undefined &&
            props.deleteParticipant.deleteParticipant.data.data !== undefined &&
            props.deleteParticipant.deleteParticipant.data.success === true) {

            if (this.state.triggerDelete === true) {

                this.setState({ triggerDelete: false });
                this.setState({ deletingParticipant: '', openDeleteParticipant: false });

                let postData = {};
                postData.page = this.state.currentPage;
                postData.orderBy = "id";
                postData.orderByAscDesc = "ASC";
                postData.perPage = this.state.perPage;
                dispatch(participantActions.getParticipantsList(apiConstants.GET_PARTICIPANT, postData));

            }
        }

        //IF CATEGORY ADDED SUCCESSFULLY
        if (
            props.addParticipant !== undefined &&
            props.addParticipant.addParticipant !== undefined &&
            props.addParticipant.addParticipant.data !== undefined &&
            props.addParticipant.addParticipant.data.success !== undefined &&
            props.addParticipant.addParticipant.data.success === true
        ) {
            const thisHolder = this;

            if (thisHolder.state.addParticipant === true) {
                this.setState({ participantSuccess: 'Participant added successfully!!', participantError: '' });

                setTimeout(function () {
                    thisHolder.setState({ participantSuccess: '', participantError: '' });
                    thisHolder.closeAddCatPop();

                    let postData = {};
                    postData.page = thisHolder.state.currentPage;
                    postData.orderBy = "id";
                    postData.orderByAscDesc = "ASC";
                    postData.perPage = thisHolder.state.perPage;
                    dispatch(participantActions.getParticipantsList(apiConstants.GET_PARTICIPANT, postData));

                }, 2000);
            }
        }


        // GET LIST OF CATEGORIES SUCCESS
        if (props.getParticipantsList !== undefined &&
            props.getParticipantsList.getParticipantsList.data !== undefined
        ) {
            const catDataReceived = props.getParticipantsList.getParticipantsList.data;
            this.setState({
                getParticipantsList: catDataReceived.data,
                totalPage: catDataReceived.data.totalPages || 0,
                totalDataCount: catDataReceived.totalCount || catDataReceived.data.length,
            })

        }

        // check if category is ready to edit
        if (props.getParticipant !== undefined &&
            props.getParticipant.editParticipantData !== undefined &&
            props.getParticipant.editParticipantData.data !== undefined &&
            props.getParticipant.editParticipantData.data.data !== undefined
        ) {
            const editingParticipantData = props.getParticipant.editParticipantData.data.data;
            if (this.state.editingParticipantHold === true) {

                this.setState({
                    name: editingParticipantData[0].name,
                    gender: editingParticipantData[0].gender,
                    age: editingParticipantData[0].age,
                    type: editingParticipantData[0].type,
                    participant_date: editingParticipantData[0].participant_date,
                    pditingParticipantError: '',
                    pditingParticipantSuccess: '',
                })
            }
        }


        // IF CATEGORY UPDATED SUCCESSFULLY
        if (
            props.addParticipant !== undefined &&
            props.addParticipant.addParticipant !== undefined &&
            props.addParticipant.addParticipant.data !== undefined &&
            props.addParticipant.addParticipant.data.success !== undefined &&
            props.addParticipant.addParticipant.data.success === true
        ) {
            const thisHolder = this;
            //console.log("SSS", thisHolder.state.triggerEditParticipant)
            if (thisHolder.state.triggerEditParticipant === true) {

                this.setState({ pditingParticipantError: '', pditingParticipantSuccess: 'Participant updated succesfully!!' });
                const thisHolder = this;
                setTimeout(function () {

                    thisHolder.closeEditCatPop();

                    thisHolder.setState({ pditingParticipantError: '', pditingParticipantSuccess: '', triggerEditParticipant: false });

                    let postData = {};
                    postData.page = thisHolder.state.currentPage;
                    postData.orderBy = "id";
                    postData.orderByAscDesc = "ASC";
                    postData.perPage = thisHolder.state.perPage;
                    dispatch(participantActions.getParticipantsList(apiConstants.GET_PARTICIPANT, postData));


                }, 2000);
            }
        }

    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(participantActions.getParticipantsList(apiConstants.GET_PARTICIPANT, postData));
    }


    // hit api and get category data for selected list range
    changeTableData = (e) => {
        const { dispatch } = this.props;

        this.setState({ perPage: parseInt(e.target.value) });

        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = parseInt(e.target.value);

        dispatch(participantActions.getParticipantsList(apiConstants.GET_PARTICIPANT, postData));
    }

    /*
    * searchCategories - User can search data from the database and it will appear
    */
    searchCategories(keyword) {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;


        if (keyword.target.value !== '') {
            postData.search = keyword.target.value;
            dispatch(participantActions.getParticipantsList(apiConstants.FIND_CATEGORIES, postData));
        } else {
            dispatch(participantActions.getParticipantsList(apiConstants.GET_PARTICIPANT, postData));
        }
    }

    //on change set category title to state
    onChangeCatTitle = (e) => {
        if (e.target.type === "file") {

            var extArr = ["image/jpeg", "image/jpg", "image/png"];
            const files = e.target.files;
            const target = e.target;
            var forimgState = [target.name + "_error"];

            if (extArr.indexOf(files[0].type) > -1) {
                this.setState({ [target.name]: files[0] });
            } else {
                this.setState({ [forimgState]: "One of the file type not suported" })
                e.target.value = null;
                this.setState({ [e.target.name]: '' })
            }
        }
        else { this.setState({ [e.target.name]: e.target.value }); }
    }

    handleDateChange = date => {
        this.setState({
            participant_date: date
        });
    }

    //close add category popup
    closeAddCatPop = () => {
        this.setState({
            participantSuccess: '',
            participantAdd: false,
            participantTitle: '',
            addParticipant: false
        });
    }

    //save category to collection
    handleSubmit = () => {
        const { dispatch } = this.props;
        this.setState({ participantError: '' });
        this.setState({ categoryError: '', participant_image_error: '' });
        const { name, gender, age, type, participant_date, participant_image } = this.state;
        console.log("ssssssssss", this.state.participant_image)
        if (name === undefined || name === '') {
            this.setState({ participantError: 'name title required!!' })
        }
        else if (participant_image === undefined || participant_image === '') { this.setState({ participant_image_error: 'participant_image  required!!' }) }
        else {

            this.setState({ participantError: '', addParticipant: true })

            const postData = {};
            postData.name = name;
            postData.gender = gender;
            postData.age = age;
            postData.type = type;
            postData.participant_date = participant_date;




            const logoImage = new FormData();
            logoImage.append('participant_image', participant_image);

            commonService.withTokenAndFormData(apiConstants.SAVE_PARTICIPANT_IMAGE, logoImage).then(
                res => {
                    //get image title from response
                    if (res.data !== undefined && res.data.data !== undefined) {
                        postData.participant_image = res.data.data;
                    }
                    dispatch(participantActions.saveParticipant(apiConstants.SAVE_PARTICIPANT, postData));
                    this.closeAddCatPop()

                },
                error => { }
            );


        }
    }


    handleSubmitEditCat = () => {
        const { dispatch } = this.props;
        this.setState({ pditingParticipantError: '' });
        const { name, gender, age, type, participant_date } = this.state;
        if (name === undefined || name === '') { this.setState({ participantError: 'name title required!!' }) }

        else {
            this.setState({ participantError: '', addParticipant: true })

            const postData = {};
            postData.participantId = this.state.editingParticipantId;
            postData.name = name;
            postData.gender = gender;
            postData.type = type;
            postData.age = age;
            postData.participant_date = participant_date;

            // update category data to cololection
            dispatch(participantActions.saveParticipant(apiConstants.UPDATE_PARTICIPANT, postData));
            this.closeEditCatPop()
        }
    }


    // popup for editing the category
    editParticipant = (participantId) => {

        const { dispatch } = this.props;
        this.setState({
            editingParticipantId: participantId,
            enableEditingParticipant: true,
            pditingParticipantError: '',
            pditingParticipantSuccess: '',
            editingParticipantHold: true,
        });

        const postData = {};
        postData.participantId = participantId;

        dispatch(participantActions.getParticipantById(apiConstants.GET_PARTICIPANT_BY_ID, postData));
    }

    closeEditCatPop = () => {
        this.setState({ editingParticipantId: '', enableEditingParticipant: false, triggerEditParticipant: false });
    }


    openAddCategory = () => {
        this.setState({
            participantAdd: !this.state.participantAdd,
            participantSuccess: '',
            participantTitle: '',
            parentcat: '',
            addParticipant: false
        });

    }

    handleClose = () => {
        this.setState({ participantAdd: !this.state.participantAdd })
    };


    deletePopupOpen = (participantId) => {
        this.setState({ deletingParticipant: participantId, openDeleteParticipant: true });
    }

    closeDeletePopup = (participantId) => {
        this.setState({ deletingParticipant: '', openDeleteParticipant: false });
    }

    // after conform click to delete cat
    deletingParticipantRecord = () => {
        this.setState({ triggerDelete: true });

        const { dispatch } = this.props;
        const postData = {};
        postData.participantId = this.state.deletingParticipant;
        dispatch(participantActions.deleteParticipant(apiConstants.DELETE_PARTICIPANT, apiConstants.GET_PARTICIPANT, postData));
        this.closeDeletePopup()
    }

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const { classes } = this.props;
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_CATEGORY}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800">Participant</h1>
                                <a href="javascript:void(0)"
                                    onClick={() => this.openAddCategory()}
                                >
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>

                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" placeholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" aria-controls="dataTable" onChange={(e) => this.searchCategories(e)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>



                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">Name</th>
                                                    <th scope="10%">Gender</th>
                                                    <th scope="10%">Age</th>
                                                    <th scope="col">Participant Date</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {

                                                    this.state.getParticipantsList != undefined &&
                                                        this.state.getParticipantsList.length > 0 ?
                                                        this.state.getParticipantsList.map((thisCat, index) => {
                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td>{thisCat.name}</td>
                                                                    <td>{thisCat.gender}</td>
                                                                    <td>{thisCat.age}</td>
                                                                    <td>{thisCat.participant_date}</td>
                                                                    <td>
                                                                        <a
                                                                            className="actionIcon"
                                                                            title="Edit"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.editParticipant(thisCat._id)}
                                                                        ><span><img src="assets/img/svg/EditIcon.png" alt="Edit" /></span></a>
                                                                        <a className="actionIcon"
                                                                            title="Delete"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.deletePopupOpen(thisCat._id)}
                                                                        ><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="6" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add category popup */}
                    <Dialog
                        open={this.state.participantAdd}
                        aria-labelledby="category-title"
                        aria-describedby="save-category-description"
                    >
                        <DialogTitle id="crop-image-dialog-title" className={classes.root}>Add Participant</DialogTitle>
                        <DialogContent className={classes.contentRoot}>
                            <div className="col-md-12 col-xs-12">
                                <p style={{ color: 'red' }}>{this.state.participantError}</p>
                                <p style={{ color: 'green' }}>{this.state.participantSuccess}</p>
                            </div>
                            <div class="row">
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="Name"
                                            className="form-control"
                                            name="name"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.participantError}</p>
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Gender</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="Gender"
                                            className="form-control"
                                            name="gender"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Age</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="age"
                                            className="form-control"
                                            name="age"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Type</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="type"
                                            className="form-control"
                                            name="type"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Participant Date</label>
                                        {/* <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="Participant Date"
                                            className="form-control"
                                            name="participant_date"
                                        /> */}
                                        <DatePicker
                                            selected={this.state.participant_date}
                                            onChange={this.handleDateChange}
                                            className="form-control"
                                            popperPlacement='top-start'
                                            name="participant_date"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_CATEGORY_IMAGE}</label>
                                        <input
                                            type="file"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            className="form-control"
                                            name="participant_image"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.participant_image_error}</p>
                                        <p style={{ color: 'green' }}>{this.state.categorySuccess}</p>
                                    </div>
                                </div>
                            </div>
                        </DialogContent>


                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmit(e)}>{siteConstants.LABEL_SAVE}</Button>
                            <Button variant="contained" onClick={() => this.closeAddCatPop()}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>



                    {/* edit category popup */}
                    <Dialog
                        open={this.state.enableEditingParticipant}
                        aria-labelledby="edit-category-title"
                        aria-describedby="edit-category-description"
                    >
                        <DialogTitle id="crop-image-dialog-title" className={classes.root}>Edit</DialogTitle>
                        <DialogContent className={classes.contentRoot}>
                            <div className="col-md-12 col-xs-12">
                                <p style={{ color: 'red' }}>{this.state.pditingParticipantError}</p>
                                <p style={{ color: 'green' }}>{this.state.pditingParticipantSuccess}</p>
                            </div>
                            <div class="row">
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="Name"
                                            className="form-control"
                                            name="name"
                                            value={this.state.name !== undefined ? this.state.name : ''}
                                        />
                                        <p style={{ color: 'red' }}>{this.state.participantError}</p>
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Gender</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="Gender"
                                            className="form-control"
                                            name="gender"
                                            value={this.state.gender !== undefined ? this.state.gender : ''}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Age</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="age"
                                            className="form-control"
                                            name="age"
                                            value={this.state.age !== undefined ? this.state.age : ''}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Participant Date</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="Participant Date"
                                            className="form-control"
                                            name="participant_date"
                                            value={this.state.participant_date !== undefined ? this.state.participant_date : ''}

                                        />
                                    </div>
                                </div>
                            </div>

                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmitEditCat(e)}>{siteConstants.LABEL_SAVE}</Button>
                            <Button variant="contained" onClick={() => this.closeEditCatPop()}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>



                    {/* notify about delete */}
                    <Dialog open={this.state.openDeleteParticipant} aria-labelledby="delete-tax-notify" >
                        <DialogTitle className={classes.root}>
                            {siteConstants.BTN_DELETE}
                        </DialogTitle>
                        <DialogContent>
                            {siteConstants.LABEL_SURE_DELTE_TAX_RECORD}
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.deletingParticipantRecord(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                            <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>


                    <Footer />
                </div>



            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, addParticipant, getParticipantsList, getParticipant, editParticipant, deleteParticipant } = state;
    return {
        language,
        addParticipant,
        getParticipantsList,
        getParticipant,
        editParticipant,
        deleteParticipant

    };
}

export default connect(mapStateToProps)(withStyles(styles)(Participant));